import React from "react";
import cn from "classnames";
import { Link } from "react-router-dom";
import styles from "./Hero.module.sass";
import ScrollButton from "../../../components/ScrollButton";
import Image from "../../../components/Image";

const Hero = ({ scrollToRef }) => {
  return (
    <div className={styles.hero}>
      <div className={cn("container", styles.container)}>
        <div className={styles.col}>
          <div className={styles.preview}>
            {/* Main hero image */}
            <div className={styles.heroImage}>
              <img
                src="/images/content/OpcoHero.svg"
                alt="Connexion OPCO CFA - Facturation et envoi dossiers automatique Edutio"
                className={styles.contractHero}
              />
            </div>
            
            {/* Animated CERFA background */}
            <div className={styles.cerfaBackground}>
              <img
                src="/images/content/factuIllus.png"
                alt="CERFA Document"
                className={styles.cerfaIllus}
              />
            </div>
            
            {/* Avatar in foreground */}
            <div className={styles.avatarForeground}>
              <img
                src="/images/content/AvatarOpco.svg"
                alt="User Avatar"
                className={styles.avatarRight}
              />
            </div>
          </div>
        </div>
        <div className={styles.col}>
          <div className={styles.wrap}>
            <div className={cn("stage", styles.stage)}>
              Connexion OPCO automatisée
            </div>
            <h1 className={cn("h1", styles.title)}>
              Connexion directe aux 11 OPCO : envoi dossiers et facturation
            </h1>
            <div className={styles.text}>
              Connectez-vous aux 11 OPCO français (OPCO2i, Atlas, Akto, OPCO EP...) : envoi automatique des dossiers, suivi des financements en temps réel et facturation simplifiée. Fini la ressaisie manuelle.
            </div>
            <div className={styles.btns}>
              <Link className={cn("button", styles.button)} to="/contact">
                Essayer gratuitement
              </Link>
              <Link
                className={cn("button-stroke", styles.button)}
                to="/contact"
              >
                Contact
              </Link>
            </div>
            <div className={styles.scrollWrapper}>
              <ScrollButton
                onScroll={() => {
                  if (scrollToRef && scrollToRef.current) {
                    scrollToRef.current.scrollIntoView({ behavior: "smooth" });
                  }
                }}
                className={styles.scroll}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
